import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui';
import { JobBadge } from '../JobBadge/JobBadge';
import { QualityBadge } from '../QualityBadge/QualityBadge';
import { RewardDisplay } from '../RewardDisplay/RewardDisplay';
import { DeadlineCountdown } from '../DeadlineCountdown/DeadlineCountdown';
import type { Job } from '@/types/worker';
import styles from './JobCard.module.css';

interface JobCardProps {
    job: Job;
}

export function JobCard({ job }: JobCardProps) {
    const navigate = useNavigate();

    return (
        <Card
            className={styles.card}
            hoverable
            onClick={() => navigate(`/home/${job.uuid}`)}
        >
            <div className={styles.header}>
                <h3 className={styles.title}>{job.title}</h3>
                <QualityBadge tier={job.quality_tier} />
            </div>

            <p className={styles.description}>{job.description.slice(0, 120)}{job.description.length > 120 ? '...' : ''}</p>

            <div className={styles.tags}>
                {job.required_professions.map((p) => (
                    <JobBadge key={p.uuid} profession={p} />
                ))}
            </div>

            <div className={styles.footer}>
                <RewardDisplay amount={job.reward_amount} currency={job.currency} />
                <DeadlineCountdown deadline={job.deadline} />
            </div>

            {job.has_claimed && (
                <span className={styles.claimedBadge}>Ya reclamado</span>
            )}
        </Card>
    );
}
